export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Portfolio", path: "/portfolio" },
  { label: "Blog", path: "/blog" },
  { label: "Contact Us", path: "/contact" },
];

export const FOOTER_LINKS = {
  "Quick Links": [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    { label: "Services", path: "/services" },
    { label: "Portfolio", path: "/portfolio" },
    { label: "Blog", path: "/blog" },
    { label: "Contact Us", path: "/contact" },
  ],
  Services: [
    { label: "AI Development", path: "/services" },
    { label: "Web Development", path: "/services" },
    { label: "Mobile Apps", path: "/services" },
    { label: "Generative AI", path: "/services" },
    { label: "RAG Systems", path: "/services" },
    { label: "Enterprise Software", path: "/services" },
  ],
};

export const CONTACT_INFO = {
  email: "neuronixtechnologies@gmail.com",
  phone: "9187376646",
  phoneE164: "+919187376646",
  address: "Near Secab Primary College Bijapur 586101",
  whatsapp: "919187376646",
};

export const SITE_META = {
  name: "Neuronix Technologies",
  tagline: "Building smart, scalable tech solutions that drive innovation and transform businesses.",
};
